import { render } from "./BasicStepSingleAnswerTempalte.vue?vue&type=template&id=1609dd04"
import script from "./BasicStepSingleAnswerTempalte.vue?vue&type=script&lang=js"
export * from "./BasicStepSingleAnswerTempalte.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator,QForm,QInput,QBtn});
